export const formFieldNames = {
	positions: 'positions',
	positionCode: 'positionCode',
	workConditionsCode: 'workConditionsCode',
	gradeList: 'gradeList',
	salarySupplement: 'salarySupplement',
	gradeCoeff: 'gradeCoeff',
	tariffRate: 'tariffRate',
	gradeLevel: 'gradeLevel',
}